import React from 'react'
import { Constants, FILE_ERROR } from '@/utils/constants/commonConstants'
import { COLOR_CODE } from '@/utils/constants/colors'

/**
 * UploadErrorMessage component displays formatted error messages for file uploads
 * 
 * @param {Object} props - The component props
 * @param {Object} props.uploadErrorMessage - The error message object containing upload error details
 * @param {number} props.uploadErrorMessage.data.processedRecords - Number of successfully processed records
 * @param {number} props.uploadErrorMessage.data.skippedRecords - Number of failed records
 * @param {string[]} props.uploadErrorMessage.data.validationErrors - Array of validation error messages
 * @returns {JSX.Element} The formatted error message component
 */
const UploadErrorMessage = ({ uploadErrorMessage }) => {
  if (!uploadErrorMessage?.data) {
    return null
  }

  const { data } = uploadErrorMessage

  return (
    <div className="flex flex-col space-y-1">
      <span className="font-semibold">{Constants.UploadError}:</span>
      <span style={{ color: COLOR_CODE._FFFFFF }}>
        {FILE_ERROR.recordsSuccessfullyUploaded(data.processedRecords)}
      </span>
      <b>{FILE_ERROR.recordsFailed(data.skippedRecords)}</b>
      <span>{FILE_ERROR.fileUploadErrorMessage}</span>
      <div>
        {data.validationErrors?.map((err, index) => (
          <span key={index}>{err}</span>
        ))}
      </div>
    </div>
  )
}

export default UploadErrorMessage
